import ServiceCRUD from '../../../../services/ServiceGasOrder';

class OpportunityListService extends ServiceCRUD {
  constructor() {
    super(`/api/relatorio-oportunidades`);
  }
}

export default new OpportunityListService();
